<template>
    <div class="zhaohui_mima">
        <div class="zhaohui_zhong">
            <p class="zh_tilte">{{ $t('Retrieve.zh_mima') }}</p>
            <div class="JIU-mima">
                <div class="p-mima-text"><p>⁎</p>{{ $t('Retrieve.shoujihao') }}</div>
                <div class="JIU-INPUT">
                    <span class="iconfont icon-dianhua"></span>
                    <input type="text" :placeholder="$t('Retrieve.shoujihao')" v-model="sjh" @blur="shoujiHao(sjh)">
                </div>
                <p class="zihongti" v-show="tishi">{{ $t('Retrieve.p_tishi') }}</p>
            </div>
            <div class="queren-xiugai" @click="ZhuiHui_int">{{ $t('Retrieve.zhaohui') }}</div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default{
        data(){
            return{
                sjh:'',
                tishi:false,
            }
        },
        methods:{
            shoujiHao(e){
                let yz = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                if(yz.test(e)){
                    this.tishi= false;
                }else{
                    this.tishi= true;
                }
            },
            ZhuiHui_int(){
                console.log(this.sjh);
                const data = {
                    phonesss:this.sjh
                }
                axios.post('api/index/wangji',data)
                .then(response => {
                    // 处理请求成功的响应
                    console.log(response.data);
                    if(response.data.code==1){
                        this.$alert(`这是您的密码：${response.data.data}`, '找回成功', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$message({
                                type: 'info',
                                message: `请妥善保管，请勿丢失`
                                });
                            }
                        });
                    }else{
                        this.$message.warning('手机号暂无注册，请前往注册')
                    }
                    
                            
                })
                .catch(error => {
                    // 处理请求失败的错误
                   console.error(error);
                });
            }
        }
    } 
</script>
<style scoped lang="scss">
    .zhaohui_mima{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .zhaohui_zhong{
            width: 420px;
            height: 260px;
            display: flex;
            overflow: hidden;
            flex-direction: column;
            align-items: center;
            margin-top: 35px;
            .zh_tilte{
                width: 100%;
                text-align: center;
                font-size: var(--nav-text-fsize30);
                font-weight: bold;
                color: var(--them-color);
            }
            .JIU-mima{
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 85px;
            margin-top: 35px;
            .p-mima-text{
                font-size: 14px;
                font-family: YuanTi;
                font-weight: bold;
                display: flex;
                align-items: center;
                color: var(--text-color);
                p{
                    margin-bottom: 5px;
                    margin-right: 3px;
                    color: #f00;
                }
            }
            .JIU-INPUT {
                    width: 100%;
                    height: 35px;
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-top: 9px;
                    
                    input {
                        width: 93%;
                        height: 100%;
                        padding-left: 35px;
                        background-color: var(--zh-input-background);
                        border: solid 1px var(--zh-input-background);
                        outline: none;
                        color: var(--them-color);
                        transform: 0.2s;
                    }
                    input:hover{
                        background-color: var(--zh-input-hover);
                        border: solid 1px var(--zh-input-hover);
                        transform: 0.2s;
                    }
                    input:focus{
                        border: solid 1px var(--text-color-xiugai);
                        background-color: var(--them-background);
                    }
                    span:nth-child(1) {
                        position: absolute;
                        left: 10px;
                        font-size: 18px;
                        color: var(--them-color);
                        margin-top: -2px;
                    }
                }
                .zihongti{
                    font-size: var(--nav-text-fsize12);
                        color: var(--tishi-color);
                        margin-top: 2px;
                }
            }
            .queren-xiugai{
                width: 100%;
                height: 40px;
                text-align: center;
                line-height: 40px;
                font-weight: bold;
                font-family: YuanTi;
                font-size: 14px;
                cursor: pointer;
                background-color: var(--lan-background);
                color: #fff;
                border-radius: 5px;
                margin-top: 25px;
            }
        }
    }
</style>